<template>
  <div class="container-fluid">
    <div class="card animated fadeIn">
      <b-row>
        <b-col sm=8>
          <b-card>
            <div slot="header">
              <strong>Quick Edit: </strong>{{config.name}}
            </div>
            <div>
              <div>
                <div>
                  <b-form @submit.prevent="updateConfig()">
                    <b-form-group label="Name" label-for="name" :label-cols-sm="2">
                      <b-form-input type="text" v-model="config.name" v-validate="'required'" id="name" name="name" class="form-control" :class="{ 'is-invalid': submitted && errors.has('name') }"></b-form-input>
                      <div v-if="submitted && errors.has('name')" class="invalid-feedback">{{ errors.first('name') }}</div>
                    </b-form-group>
                    <b-form-group label="Snippet" label-for="snippet" :label-cols-sm="2">
                      <b-form-textarea max-rows="8" v-model="config.snippet" v-validate="'required'" id="snippet" name="snippet" class="form-control" :class="{ 'is-invalid': submitted && errors.has('snippet') }" @keydown.tab.prevent="tabber($event)"></b-form-textarea>
                      <div v-if="submitted && errors.has('name')" class="invalid-feedback">{{ errors.first('snippet') }}</div>
                    </b-form-group>
                    <b-form-group label="Models" label-for="models" :label-cols-sm="2">
                      <multiselect v-model="value" :options="options" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="false" placeholder="search ..." :show-labels="false" label="name" track-by="id" :preselect-first="true" :hideSelected="false">
                        <template slot="selection" slot-scope="{ values, search }">
                          <!--   <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Model selected</span> -->
                        </template>
                      </multiselect>
                    </b-form-group>
                    <div  class="text-center">
                      <button class="btn btn-primary">Save</button>
                    </div>
                  </b-form>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col sm=4>
          <b-card>
            <div slot="header">
              <strong>Details</strong>
            </div>
            Info goes here
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<!-- 
default vale: https://michaelstivala.com/setting-the-default-value-of-a-select-tag-in-vuejs/
https://medium.com/@hugodesigns/how-to-use-the-most-complete-selecting-solution-for-vue-js-f991b2605364 
https://medium.com/employbl/build-tagging-with-vue-multiselect-and-laravel-tags-960c260df438

saving selected tags:
https://quickadminpanel.com/blog/add-tags-to-articles-laravel-many-to-many-relationships-with-select2/

for selected tags using only ids:
https://github.com/shentao/vue-multiselect/issues/133
-->

<script>
import Multiselect from 'vue-multiselect'


export default {
  components: {

    Multiselect,
  },
  data() {

    return {
      config: {
        product_list: null,

      },

      submitted: false,
      value: [],
      options: [],
      selectedIds: [],


    };

  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    },

  },
  // https://github.com/shentao/vue-multiselect/issues/263
  watch: {
    value(newValues) {
      this.selectedIds = newValues.map(obj => obj.id);
    }
  },


  created() {
    let id = this.rowData.id;
    // let uri = `/api/configs/${this.$route.params.id}`;
    let uri = `/api/configs/` + id;
    axios.get(uri).then((response) => {
      this.config = response.data.data.config;
      this.options = response.data.data.all_prod_tags;
      this.value = response.data.data.my_prod_tags;

    });


  },
  computed: {
    optionsArray() {
      return Object.keys(this.options).map(i => this.options[i]);
    }
  },


  methods: {
    // toArray(obj_obj) {
    //   return Object.keys(obj_obj).map(i => obj_obj[i]);
    // },
    fetchOptions() {
      let uri = `/api/configs/${this.$route.params.id}`;
      axios.get(uri).then((response) => {
        this.config = response.data.data.config;
        this.options = response.data.data.all_prods_list;
        // this.value = response.data.data.sel_prods_list;
      });
    },



    updateConfig() {
      this.submitted = true;
      // this.config.product_list =[21];
      this.config.product_list = this.selectedIds;
      this.$validator.validate().then(valid => {
        if (valid) {
          let uri = `/api/configs/${this.config.id}`;
          axios.patch(uri, this.config).then((response) => {


            if (response.data.success === true) {
              this.makeToast('info', 'Config updated.');
            } else {
              this.makeToast('danger', 'Unable to update config.');
            }

          });

        }
      });
    },
    makeToast(variant = null, message = null) {

      this.$bvToast.toast(message, {
        // title: `Config Updated ${variant || 'default'}`,
        title: `Notification:`,
        variant: variant,
        toaster: 'b-toaster-top-center',
        solid: true
      });
      // toast.show();
    },

    tabber(event) {
      let text = this.config.snippet,
        originalSelectionStart = event.target.selectionStart,
        textStart = text.slice(0, originalSelectionStart),
        textEnd = text.slice(originalSelectionStart);

      this.config.snippet = `${textStart}\t${textEnd}`
      event.target.value = this.config.snippet // required to make the cursor stay in place.
      event.target.selectionEnd = event.target.selectionStart = originalSelectionStart + 1
    }

  }

}
</script>

<style>
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #20a8d8;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

.multiselect__option--highlight {
  background: #20a8d8;
  outline: none;
  color: white;
}

.multiselect__option--highlight:after {
  content: attr(data-select);
  background: #20a8d8;
  color: white;
}
</style>
